<template>
    <div class="wrapper-form-block-enderecoSocio" :inert="pPreview">
      <TrfFormularioBaseEnderecoFormulario
        @update:form-data="(formData) => setEndereco(formData)"
        id="form-block-socio-endereco"
        ref="BlockSocioEndereco"
        :required="required"
        :pIsDirty="pIsDirty"
        :pPreview="pPreview"
        :formData="formData"
        @set:validacao="setValidacao"
        @is:mounted="inicializarCampos"
      >
        <template #titulo>
          <p><strong>Qual o endereço do sócio?</strong></p>
        </template>
      </TrfFormularioBaseEnderecoFormulario>
    </div>
  </template>
  <script>
  import { defineAsyncComponent } from 'vue';
import Endereco from '../../../views/Legalize/CadastroDeProcessos/Models/endereco.model';
  export default {
    name: 'TrfBlocoEnderecoSocio',
    emits: ['update:form-data', 'set:validacao'],
    components: {
      TrfFormularioBaseEnderecoFormulario: defineAsyncComponent(() => import('../../FormularioBaseEndereco/FormularioBaseEnderecoFormulario.vue'))
    },
    props: {
        pEnderecoFormData: {
            type: Object,
            default: new Endereco()
        },
        pPreview: {
            type: Boolean,
            default: true
        },
        required: {
          type: Boolean,
          default: false
        },
        pIsDirty: {
          type: Boolean,
          default: false
        },
        pSocioEmPreenchimento: {
            type: Object,
            default: null
        },
    },
    data() {
      return {
        formData: {
            endereco: this.pSocioEmPreenchimento?.socio?.endereco? {...this.pSocioEmPreenchimento.socio.endereco} : this.pEnderecoFormData
        },
        isDirty: this.pIsDirty,
        isCampoInicializado: false
      };
    },
    methods: {
        async inicializarCampos() {
          if (!this.$refs.BlockSocioEndereco) return;
          if (!this.pSocioEmPreenchimento?.socio?.endereco) {
            this.isCampoInicializado = true;
          } else {
            const endereco = new Endereco();
            endereco.asModel(this.pSocioEmPreenchimento.socio.endereco);
            endereco.pais = this.pSocioEmPreenchimento.socio.endereco.pais;
            endereco.estado = this.pSocioEmPreenchimento.socio.endereco.estado;
            endereco.semNumero = this.pSocioEmPreenchimento.socio.endereco.semNumero;
            this.$refs.BlockSocioEndereco.inicializarCampos(endereco);
            await this.$nextTick();
            this.isDirty = true;
            this.isCampoInicializado = true;
            this.emitFormData();
          }
        },
        setValidacao(validacao) {
          this.$emit('set:validacao', validacao)
        },
        setEndereco(formData) {
            this.formData.endereco = formData;
            this.emitFormData(this.formData);
            this.isDirty = true;
        },
        emitFormData(value = this.formData) {
          if (!this.isCampoInicializado) return;
          this.$emit('update:form-data', value)
        }
    }
  };
  </script>
  